import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const DeleteCoUserFromGroupApi = createAsyncThunk('co-users/delete-group-member', async ({ requestHeaders }, { getState, rejectWithValue }) => {
  const { loginToken } = getState();
  const authToken = loginToken?.response?.token;
  try {
    const response = await fetch(
      `${ROOT_URL}/co-users/delete-group-member`,
      {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(requestHeaders),
      },
    );
    const result = await response.json();
    return result;
  } catch (error) {
    return rejectWithValue(error.response);
  }
});

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const DeleteUserFromGroup = createSlice(
  {
    name: 'deletegroupuser',
    initialState,
    reducers: {},
    extraReducers: {
      [DeleteCoUserFromGroupApi.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [DeleteCoUserFromGroupApi.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        isError: false,
        response: action.payload,
      }),
      [DeleteCoUserFromGroupApi.rejected]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      }),
    },
  },
);

export default DeleteUserFromGroup;
